var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoverCompareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_513_1103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.351562 6.82031C0.545719 6.82031 0.703125 6.66291 0.703125 6.46875V5.53125C0.703125 5.33709 0.545719 5.17969 0.351562 5.17969C0.157406 5.17969 0 5.33709 0 5.53125V6.46875C0 6.66291 0.157406 6.82031 0.351562 6.82031Z",
    fill: "url(#paint0_linear_513_1103)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.351562 4.47656C0.545719 4.47656 0.703125 4.31916 0.703125 4.125V3.1875C0.703125 2.99334 0.545719 2.83594 0.351562 2.83594C0.157406 2.83594 0 2.99334 0 3.1875V4.125C0 4.31916 0.157406 4.47656 0.351562 4.47656Z",
    fill: "url(#paint1_linear_513_1103)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.28906 0.492188H0.820312C0.367992 0.492188 0 0.86018 0 1.3125V1.78125C0 1.97541 0.157406 2.13281 0.351562 2.13281C0.545719 2.13281 0.703125 1.97541 0.703125 1.78125V1.3125C0.703125 1.24788 0.755695 1.19531 0.820312 1.19531H1.28906C1.48322 1.19531 1.64062 1.03791 1.64062 0.84375C1.64062 0.649594 1.48322 0.492188 1.28906 0.492188Z",
    fill: "url(#paint2_linear_513_1103)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.69531 1.19531H3.63281C3.82697 1.19531 3.98438 1.03791 3.98438 0.84375C3.98438 0.649594 3.82697 0.492188 3.63281 0.492188H2.69531C2.50116 0.492188 2.34375 0.649594 2.34375 0.84375C2.34375 1.03791 2.50116 1.19531 2.69531 1.19531Z",
    fill: "url(#paint3_linear_513_1103)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63281 10.8047H2.69531C2.50116 10.8047 2.34375 10.9621 2.34375 11.1562C2.34375 11.3504 2.50116 11.5078 2.69531 11.5078H3.63281C3.82697 11.5078 3.98438 11.3504 3.98438 11.1562C3.98438 10.9621 3.82697 10.8047 3.63281 10.8047Z",
    fill: "url(#paint4_linear_513_1103)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.351562 9.16406C0.545719 9.16406 0.703125 9.00666 0.703125 8.8125V7.875C0.703125 7.68084 0.545719 7.52344 0.351562 7.52344C0.157406 7.52344 0 7.68084 0 7.875V8.8125C0 9.00666 0.157406 9.16406 0.351562 9.16406Z",
    fill: "url(#paint5_linear_513_1103)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.28906 10.8047H0.820312C0.755695 10.8047 0.703125 10.7521 0.703125 10.6875V10.2188C0.703125 10.0246 0.545719 9.86719 0.351562 9.86719C0.157406 9.86719 0 10.0246 0 10.2188V10.6875C0 11.1398 0.367992 11.5078 0.820312 11.5078H1.28906C1.48322 11.5078 1.64062 11.3504 1.64062 11.1562C1.64062 10.9621 1.48322 10.8047 1.28906 10.8047Z",
    fill: "url(#paint6_linear_513_1103)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1797 0.492188H6.35157V0.351562C6.35157 0.157406 6.19417 0 6.00001 0C5.80586 0 5.64845 0.157406 5.64845 0.351562V0.492188H5.03907C4.84492 0.492188 4.68751 0.649594 4.68751 0.84375C4.68751 1.03791 4.84492 1.19531 5.03907 1.19531H5.64845V7.05469H4.03625L4.13921 6.95173C4.27651 6.81443 4.27651 6.59184 4.13921 6.45455C4.00192 6.31725 3.77933 6.31725 3.64204 6.45455L2.93891 7.15767C2.80161 7.29497 2.80161 7.51755 2.93891 7.65485L3.64204 8.35798C3.77933 8.49527 4.00192 8.49527 4.13921 8.35798C4.27651 8.22068 4.27651 7.99809 4.13921 7.8608L4.03625 7.75781H5.64845V10.8047H5.03907C4.84492 10.8047 4.68751 10.9621 4.68751 11.1562C4.68751 11.3504 4.84492 11.5078 5.03907 11.5078H5.64845V11.6484C5.64845 11.8426 5.80586 12 6.00001 12C6.19417 12 6.35157 11.8426 6.35157 11.6484V11.5078H11.1797C11.632 11.5078 12 11.1398 12 10.6875V1.3125C12 0.86018 11.632 0.492188 11.1797 0.492188ZM9.06109 4.84233L8.35796 5.54545C8.22067 5.68275 7.99808 5.68275 7.86079 5.54545C7.72349 5.40816 7.72349 5.18557 7.86079 5.04827L7.96375 4.94531H6.35157V4.24219H7.96377L7.86081 4.13923C7.72351 4.00193 7.72351 3.77934 7.86081 3.64205C7.99811 3.50475 8.22069 3.50475 8.35799 3.64205L9.06111 4.34517C9.19839 4.48245 9.19839 4.70505 9.06109 4.84233Z",
    fill: "url(#paint7_linear_513_1103)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_513_1103",
    x1: 0.351562,
    y1: 6.82031,
    x2: 0.351562,
    y2: 5.17969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCAD3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_513_1103",
    x1: 0.351562,
    y1: 4.47656,
    x2: 0.351562,
    y2: 2.83594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCAD3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_513_1103",
    x1: 0.820312,
    y1: 2.13281,
    x2: 0.820312,
    y2: 0.492188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCAD3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_513_1103",
    x1: 3.16406,
    y1: 1.19531,
    x2: 3.16406,
    y2: 0.492188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCAD3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_513_1103",
    x1: 3.16406,
    y1: 11.5078,
    x2: 3.16406,
    y2: 10.8047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCAD3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_513_1103",
    x1: 0.351562,
    y1: 9.16406,
    x2: 0.351562,
    y2: 7.52344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCAD3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_513_1103",
    x1: 0.820312,
    y1: 11.5078,
    x2: 0.820312,
    y2: 9.86719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCAD3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_513_1103",
    x1: 7.41797,
    y1: 12,
    x2: 7.41797,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCAD3A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_513_1103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverCompareIcon);
export default __webpack_public_path__ + "static/media/hoverCompareIcon.228e9f32c707bbdb962a2a2588d72148.svg";
export { ForwardRef as ReactComponent };